module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-regular.4fc29212.woff";